import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-grey text-caption"
}

import { ref, watch } from 'vue'

interface Props {
  search?: string
  type?: string
  status?: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InventoryFilters',
  props: {
    search: { default: '' },
    type: { default: '' },
    status: { default: () => [] }
  },
  emits: ['update:search', 'update:type', 'update:status'],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable no-undef */
const props = __props

const emit = __emit

const searchValue = ref(props.search)
const typeValue = ref(props.type)
const statusValue = ref(props.status)

const removeStatus = (value: string) => {
  const newStatus = statusValue.value.filter(s => s !== value)
  statusValue.value = newStatus
  emit('update:status', newStatus)
}

// Equipment type options
const equipmentTypes = [
  { title: 'All Types', value: '' },
  { title: 'Laptop', value: 'laptop' },
  { title: 'Desktop', value: 'desktop' },
  { title: 'Monitor', value: 'monitor' },
  { title: 'Tablet', value: 'tablet' },
  { title: 'Other', value: 'other' }
]

// Status options
const statusOptions = [
  { title: 'Processing', value: 'processing' },
  { title: 'Troubleshooting', value: 'troubleshooting' },
  { title: 'Parts', value: 'parts' },
  { title: 'Available', value: 'available' },
  { title: 'Claimed', value: 'claimed' },
  { title: 'Delivered', value: 'delivered' }
]

watch(() => props.search, (val) => { searchValue.value = val })
watch(() => props.type, (val) => { typeValue.value = val })
watch(() => props.status, (val) => { statusValue.value = val })

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mb-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: searchValue.value,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:search', searchValue.value)))
                    ],
                    label: "Search equipment",
                    placeholder: "Search by type, manufacturer, model, donor, location, or asset tag...",
                    "prepend-inner-icon": "mdi-magnify",
                    variant: "outlined",
                    density: "comfortable",
                    clearable: "",
                    "hide-details": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: typeValue.value,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((typeValue).value = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:type', typeValue.value)))
                    ],
                    items: equipmentTypes,
                    label: "Equipment Type",
                    variant: "outlined",
                    density: "comfortable",
                    clearable: "",
                    "hide-details": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: statusValue.value,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((statusValue).value = $event)),
                      _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:status', statusValue.value)))
                    ],
                    items: statusOptions,
                    label: "Status",
                    variant: "outlined",
                    density: "comfortable",
                    "hide-details": "",
                    multiple: "",
                    "menu-props": { maxHeight: 300 }
                  }, {
                    selection: _withCtx(({ item, index }) => [
                      (index < 2)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            size: "small",
                            closable: "",
                            "onClick:close": ($event: any) => (removeStatus(item.value))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick:close"]))
                        : _createCommentVNode("", true),
                      (index === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (+" + _toDisplayString(statusValue.value.length - 2) + " more) ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})